import { render, staticRenderFns } from "./LeoOrder.vue?vue&type=template&id=08c0d696&scoped=true&"
import script from "./LeoOrder.vue?vue&type=script&lang=js&"
export * from "./LeoOrder.vue?vue&type=script&lang=js&"
import style0 from "./LeoOrder.vue?vue&type=style&index=0&id=08c0d696&lang=less&scoped=scoped&"
import style1 from "./LeoOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0d696",
  null
  
)

export default component.exports